import { DispatchListDetailsRes } from '@zonofi/zono-money-store';
import { ReactComponent as OrderIcon } from '@zonofi/svg-icons/order.svg';
import { ReactComponent as InvoiceIcon } from '@zonofi/svg-icons/invoice.svg';

interface ReferenceDetailsProps {
  dispatchNoteDetails: DispatchListDetailsRes;
}

export const ReferenceDetails = (props: ReferenceDetailsProps) => {
  const { dispatchNoteDetails } = props;
  const selectedOrders =
    dispatchNoteDetails?.orders?.length > 0
      ? dispatchNoteDetails.orders.join(', ')
      : 'NA';

  return (
    <div className="dispatch-note-detail-box font-regular">
      <span className="dispatch-note-detail-box-heading font-semibold">
        Reference
      </span>
      {dispatchNoteDetails?.orders?.length <= 0 &&
        dispatchNoteDetails?.orders?.length <= 0 && (
          <span className="dispatch-note-detail-box-content-text-value">
            No order number or invoice number is linked
          </span>
        )}
      <div className="dispatch-note-detail-box-content">
        <OrderIcon />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Order:{' '}
          </span>
          <span className="dispatch-note-detail-content-text-value">
            {selectedOrders}
          </span>
        </div>
      </div>
      <div className="dispatch-note-detail-box-content">
        <InvoiceIcon />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Invoice:{' '}
          </span>
          <span className="dispatch-note-detail-content-text-value">
            {dispatchNoteDetails?.invoiceId || 'NA'}
          </span>
        </div>
      </div>
    </div>
  );
};
